<template>
  <v-flex class="cscan-image-wrapper" :id="cscanId">
    <image-not-found v-if="cscanImgNotFound" />
    <pixel-shaded-canvas
      :img="cscanImg"
      :octColorSettings="octColorSettings"
      :canvasSize="cscanFit"
      :imgSize="cscanImgSize"/>
    <v-progress-circular v-if="isLoading" class="escalon-absolute-center" indeterminate/>
  </v-flex>
</template>

<script>
import pixelShadedCanvas from "../../../canvas/components/PixelShadedCanvas";
import imageNotFound from "../../misc/ImageNotFound";
export default {
  name: "cscanView",
  components: { pixelShadedCanvas, imageNotFound },
  props: {
    cscanFit: Object,
    cscanImgSize: Object,
    octColorSettings: Object,
    octDataLoading: Boolean,
    cscanImg: HTMLImageElement,
    cscanImgNotFound: Boolean,
    cscanImgLoading: Boolean,
    cscanId: { type: String, default: "cscan-image-wrapper"}
  },
  computed: {
    isLoading() {
      return this.cscanImgLoading || this.octDataLoading;
    }
  }
};
</script>

<style lang="scss" scoped>
.cscan-image-wrapper {
  position: relative;
  height: 100%;
}
</style>
